/**
 * The file a paste attaches to a composer: the clipboard's first file of a type the composer takes, or null when it
 * holds none and the paste is text for the box.
 *
 * @param files - The clipboard's files, as `ClipboardEvent.clipboardData.files` lists them.
 * @param allowedTypes - The MIME types the composer takes, from `pastableFileTypes`.
 */
export function pastedFile(files: ArrayLike<File>, allowedTypes: readonly string[]): File | null {
  return Array.from(files).find((file) => allowedTypes.includes(file.type)) ?? null;
}
